"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDropdown = void 0;
var react_1 = __importStar(require("react"));
var HeaderButton_1 = require("./HeaderButton");
var react_2 = require("@chakra-ui/react");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var primitives_1 = require("../../../primitives");
var colors_1 = require("../colors");
var languageGrid = {
    base: 'repeat(1, 1fr)',
    md: 'repeat(2, 1fr)',
};
var TranslationsDropdown = function (_a) {
    var displayMode = _a.displayMode;
    var _b = (0, react_1.useState)(false), isDropdownOpen = _b[0], setIsDropdownOpen = _b[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_2.useOutsideClick)({
        ref: ref,
        handler: function () { return setIsDropdownOpen(false); },
    });
    var _c = (0, useHeaderProps_1.useHeaderProps)(), _js = _c._js, siteConfiguration = _c.siteConfiguration, value = _c.userTranslationSettings, setValue = _c.onUserTranslationsSettingsChange, colorSet = _c.colorSet;
    if ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration['feature-language-dropdown']) === 'none') {
        return null;
    }
    function onChange(newValue) {
        setValue(newValue);
        setIsDropdownOpen(false);
    }
    var supportedLanguages = ((siteConfiguration === null || siteConfiguration === void 0 ? void 0 : siteConfiguration.languages) || {});
    var languages = Object.keys(supportedLanguages).map(function (langid) { return (__assign({ langid: langid }, supportedLanguages[langid])); });
    // Sort Language by langid (ISO 2 letter language code)
    languages.sort(function (a, b) { return a.langid.localeCompare(b.langid); });
    return (react_1.default.createElement(react_2.Box, { className: "header-translations", "data-feature-id": "header_translations", ref: ref }, displayMode === 'dropdown' ? (react_1.default.createElement(react_2.Popover, { isOpen: isDropdownOpen, returnFocusOnClose: false, onClose: function () { return setIsDropdownOpen(false); } },
        react_1.default.createElement(react_2.PopoverTrigger, null,
            react_1.default.createElement(HeaderButton_1.HeaderButton, { isRounded: true, onClick: function () { return setIsDropdownOpen(true); }, className: "header-language_dropdown_button", "data-feature-id": "header_language_dropdown_button", p: 4, active: isDropdownOpen },
                react_1.default.createElement(react_2.Badge, { bg: colorSet === null || colorSet === void 0 ? void 0 : colorSet.backgroundHighlight, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text, fontFamily: primitives_1.fontFamily.monoSystem, fontSize: "md" }, value.locale))),
        react_1.default.createElement(react_2.PopoverContent, { bg: colors_1.DEFAULT_BACKGROUND_COLOR, w: "auto", "aria-label": _js('Languages'), maxH: "75vh", overflowY: "auto" },
            react_1.default.createElement(LanguageList, { languages: languages, value: value, onChange: onChange })))) : (react_1.default.createElement(react_2.Accordion, { allowToggle: true },
        react_1.default.createElement(react_2.AccordionItem, { border: "none" },
            react_1.default.createElement(react_2.AccordionButton, { h: 12, fontSize: "lg", _hover: { bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR }, _focus: { outline: 0, bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR }, color: colors_1.DEFAULT_TEXT_COLOR },
                react_1.default.createElement(react_2.Flex, { alignItems: "center", justify: "space-between", flex: 1, color: colors_1.DEFAULT_TEXT_COLOR },
                    react_1.default.createElement(react_2.Badge, { bg: colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR, color: colors_1.DEFAULT_TEXT_COLOR, fontFamily: primitives_1.fontFamily.monoSystem, fontSize: "md" }, value.locale),
                    react_1.default.createElement(react_2.AccordionIcon, null))),
            react_1.default.createElement(react_2.AccordionPanel, { pb: 4 },
                react_1.default.createElement(LanguageList, { languages: languages, value: value, onChange: onChange })))))));
};
exports.TranslationsDropdown = TranslationsDropdown;
var LanguageList = function (_a) {
    var languages = _a.languages, value = _a.value, onChange = _a.onChange;
    var textColor = colors_1.DEFAULT_TEXT_COLOR;
    var activeBackgroundColor = colors_1.DEFAULT_BACKGROUND_HIGHLIGHT_COLOR;
    return (react_1.default.createElement(react_2.Grid, { templateColumns: languageGrid, p: 3 }, languages.map(function (language) { return (react_1.default.createElement(react_2.GridItem, { key: language.langid, onClick: function () {
            return onChange(__assign(__assign({}, value), { locale: language.langid }));
        }, px: 3, _hover: {
            cursor: 'pointer',
            '.iso-code': {
                bg: textColor,
                color: activeBackgroundColor,
            },
        }, className: "header-language__".concat(language.langid), "data-feature-id": "header_language_".concat(language.langid) },
        react_1.default.createElement(react_2.Flex, { align: "center" },
            react_1.default.createElement(react_2.Badge, { className: "iso-code", mr: 3, fontSize: "md", fontFamily: primitives_1.fontFamily.monoSystem, color: textColor, bg: activeBackgroundColor }, language.langid),
            react_1.default.createElement(react_2.Text, { color: textColor, fontWeight: "bold", my: 2 }, language.autoglottonym)))); })));
};
